module.exports = __webpack_public_path__ + "static/media/camera.6acbae8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/photography/camera.png
// module id = 740
// module chunks = 0